<app-traitement-data titre="Débit (min - max)" [sousTitre]="patient!.tableauDeBord?.duree?.date | aLaDateDu"
    statut="info">
    {{ patient!.tableauDeBord?.debitMin?.value ?? 'Ø' }} - {{ patient!.tableauDeBord?.debitMax?.value ?? 'Ø' }}
</app-traitement-data>